// base
import { createAction } from '@reduxjs/toolkit';

// default
export const COMPANY = 'company';
export const COMPANY_SLICE_NAME = `${COMPANY}Slice`;

// action
export const GET_COMPANY_LIST = `${COMPANY}`;
export const GET_COMPANY_NAME_LIST = `${COMPANY}/names`;
export const GET_COMPANY_DETAIL = `${COMPANY}/detail`;
export const CREATE_COMPANY = `${COMPANY}/create`;
export const UPDATE_COMPANY = `${COMPANY}/modify`;
export const DELETE_COMPANY = `${COMPANY}/delete`;

// createAction
export const getCompanyAction = createAction(GET_COMPANY_LIST);
export const getCompanyNameAction = createAction(GET_COMPANY_NAME_LIST);
export const getCompanyDetailAction = createAction(GET_COMPANY_DETAIL);
export const createCompanyAction = createAction(CREATE_COMPANY);
export const updateCompanyAction = createAction(UPDATE_COMPANY);
export const deleteCompanyAction = createAction(DELETE_COMPANY);

// actions
export const actions = {
  getCompanyAction,
  getCompanyNameAction,
  getCompanyDetailAction,
  createCompanyAction,
  updateCompanyAction,
  deleteCompanyAction
};
